// @ts-strict

import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ICampaignConfigFieldData, ICommonInputValue } from '@app/core/models/core-models';
import { LocalStorageService } from '@services/local-storage/local-storage.service';
import { isArray, isEqual } from 'lodash';

export interface RadioInputValue {
  value: string;
  system?: string;
}

@Component({
  selector: 'app-radio-input',
  templateUrl: './radio-input.component.html',
  styleUrls: ['./radio-input.component.scss']
})
export class RadioInputComponent implements OnInit, OnChanges {
  @Input() fieldInfo?: ICampaignConfigFieldData;
  @Input() configurationData?: ICampaignConfigFieldData[];
  @Input() submitted = false;
  @Output() emitValue = new EventEmitter<ICommonInputValue>();

  public panelLanguage = '';
  public checkedValue = '';
  public radioValues: string[] = [];

  constructor(private localStorageService: LocalStorageService) {}

  ngOnInit(): void {
    if (typeof this.fieldInfo?.values === 'string') {
      this.radioValues = this.fieldInfo.values.split(';');
    }
    this.panelLanguage = this.localStorageService.getPanelLang();
    this.localStorageService.panelLanguage.subscribe(panelLang => {
      if (panelLang) {
        this.panelLanguage = panelLang;
      }
    });
    if (this.configurationData) {
      const currentConfig = this.configurationData.find(value => value.system_name === this.fieldInfo?.system_name);
      if (typeof currentConfig?.config_values === 'string') {
        this.checkedValue = currentConfig.config_values;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.fieldInfo?.currentValue && !isEqual(changes.fieldInfo.currentValue, changes.fieldInfo.previousValue)) {
      this.radioValues = typeof changes.fieldInfo?.currentValue?.values === 'string' ? changes.fieldInfo.currentValue.values.split(';') : [];
    }
  }

  getValue(value: string): void {
    this.checkedValue = value;
    this.emitValue.emit({ value: this.checkedValue, system: this.fieldInfo?.system_name || '' });
  }
}
